
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 120 120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ffbb1f","d":"M104.2 0H15.8C7.1 0 0 7 0 15.8v88.4c0 8.7 7.1 15.8 15.8 15.8h88.4c8.7 0 15.8-7.1 15.8-15.8V15.8C120 7.1 112.9 0 104.2 0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M30.3 41.9c.1 0 .1 0 0 0 1.3-1.7 2.6-3.3 4.1-4.7 1.5-1.5 3-2.8 4.7-4 .3-.2.4-.7.2-1 0 0 0-.1-.1-.1L37.1 30c-2-2-5.3-2-7.4 0l-2.5 2.5c-2 2-2 5.3 0 7.3l2 2c.4.4.8.4 1.1.1zM50.7 27.6h.2c3.4-1 7-1.5 10.6-1.5 3.4 0 6.9.5 10.2 1.4.4.1.8-.1.8-.5v-4.3c0-2.9-2.3-5.2-5.2-5.2H55.2c-2.9 0-5.2 2.3-5.2 5.2v4.2c-.1.4.3.7.7.7zM61.4 30.3c-18.7 0-33.9 15.2-33.9 33.9s15.2 33.9 33.9 33.9 33.9-15.2 33.9-33.9-15.2-33.9-33.9-33.9zm0 57.8c-13.2-.1-23.9-10.8-23.8-24 0-13.2 10.8-23.9 23.9-23.8 13.2 0 23.9 10.8 23.8 23.9 0 13.2-10.7 23.9-23.9 23.9z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M62.1 44.5c-.4 0-.7.3-.7.7V63c0 .4.3.7.7.7.1 0 .2 0 .3-.1l15.8-8.2c.4-.2.5-.6.3-1-3.4-5.9-9.6-9.7-16.4-9.9z"}})])
          )
        }
      }
    